import { render, staticRenderFns } from "./add-event-admins.vue?vue&type=template&id=7f3e978f&"
import script from "./add-event-admins.vue?vue&type=script&lang=js&"
export * from "./add-event-admins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports